











import { Component, Vue } from 'vue-property-decorator';
import {GeneralService} from '../services/general-service';
import config from '../services/api-config';
import router from '../router';
import AuthService from '../services/auth-service';

@Component({
  components: {},
  props: ['progId', 'progName', 'board-name'],
})

export default class ProgramLevel extends Vue {
    progId: any;
    progName: any;
    boardName: any;
    private service = new GeneralService();
    private class_entity: UserClassModel[] = [];
    private auth = new AuthService();
    private navigateTo(entity) {
        localStorage[config.classLevl] = entity.clId;
        localStorage[config.programSelect] = JSON.stringify({val: entity.clId, user: this.auth.session.userId, part: entity.fullName, name: this.progName, board: this.boardName});
        router.push('selectEL');
    }

    mounted() {
        this.service.classlevel(this.progId)
            .then(result => { this.class_entity = result; })
            .catch(err => { console.error(`Error: ${err.message}`); });
    };
}
